
import { defineComponent } from "vue";
import store from "@/store";
import router from "@/router";

import type { ICoursesModel } from "@/interfaces/modules";
import CoursesService from "@/api/Aula/CoursesSevice";
import { SHOW_PRESCHOOL } from '@/enums';
export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: { Enable: true } as ICoursesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "Name", label: "Nombre", sortable: true },
          { key: "HeadquarterName", label: "Sede", sortable: true },
          { key: "JourneyName", label: "Jornada", sortable: true },
          { key: "LevelIdName", label: "Nivel", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Enable", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as any[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            (item.Name || "").toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            (item.HeadquarterName || "").toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            (item.JourneyName || "").toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await CoursesService.GetCourses(SHOW_PRESCHOOL.No);
      this.table.loading = false;
    },
    editUser(Id: any) {
      router.push(`courses-detail/${Id}`);
    },
    validateState(field: any): boolean {
      return this.form.record[field]?.length > 0 ? true : false;
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await CoursesService.PostCourses(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
